import { render, staticRenderFns } from "./purchaseReceivesInspectionReportsEdit.vue?vue&type=template&id=2ef86d15&scoped=true"
import script from "./purchaseReceivesInspectionReportsEdit.vue?vue&type=script&lang=js"
export * from "./purchaseReceivesInspectionReportsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef86d15",
  null
  
)

export default component.exports